import {baseRequestService} from "../base.ts";
import {Region} from "../../types/domain.ts";

export const regionsGet = () => baseRequestService<Region[]>({
    url: '/regions',
    method: 'GET',
})